<template>
  <v-app-bar fixed app class="pr-sm-6">
    <v-app-bar-nav-icon @click.stop="$emit('set-drawer')">
      <v-icon x-large color="primary">$menu</v-icon>
    </v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <span
      v-if="currentHotel"
      class="app-hotel-name notranslate"
      :class="{ title: !isMobile, 'subtitle-1': isMobile }"
      >{{ currentHotel.hotelCode + " - " + currentHotel.name }}</span
    >

    <v-spacer></v-spacer>
    <connection-select
      v-if="showConnectionSelect && !isMobile"
    ></connection-select>
    <v-btn
      v-if="user && !isMobile && !hideHotelSelector"
      id="hotel-selector-button"
      class="mx-3"
      icon
      @click="showDialog('hotelSelector')"
    >
      <v-icon color="primary" size="30">$hotel</v-icon>
    </v-btn>
    <v-menu
      v-if="user"
      offset-y
      transition="scale-transition"
      origin="top right"
      bottom
      left
      :nudge-bottom="!isMobile ? 5 : 0"
    >
      <template #activator="{ on }">
        <v-btn icon :tile="isMobile" v-on="on">
          <v-avatar class="gradient" size="35">
            <span class="title white--text text-capitalize">{{
              user.name[0]
            }}</span>
          </v-avatar>
        </v-btn>
      </template>
      <v-list dense>
        <template v-if="isMobile">
          <template v-if="!hideHotelSelector">
            <v-list-item @click="showDialog('hotelSelector')">
              <v-list-item-icon class="mr-3">
                <v-icon color="primary">$selectHotel</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("selectHotel") }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </template>
        <v-list-item id="reset-password" @click="showDialog('resetPassword')">
          <v-list-item-icon class="mr-3">
            <v-icon>$editPassword</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("resetPassword") }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <log-out></log-out>
      </v-list>
    </v-menu>
    <language-switch only-icon></language-switch>
    <default-dialog
      v-if="selectedDialog"
      :show-dialog="selectedDialog.show"
      :width="selectedDialog.width"
      :title="$t(selectedDialog.titleKey)"
      :include-actions="selectedDialog.includeActions"
      @close-dialog="closeDialog"
    >
      <template #dialog-content>
        <component
          :is="selectedDialog.content"
          :ref="selectedDialog.ref"
          :show-dialog="selectedDialog.show"
          @close-dialog="closeDialog"
        ></component>
      </template>
    </default-dialog>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dialogs from "@/mixins/dialogs";
import isMobile from "@/mixins/isMobile";

import LanguageSwitch from "@/components/globals/LanguageSwitch";
import LogOut from "@/components/globals/LogOut";
import HotelSelector from "@/components/dialogs/HotelSelector";
import DefaultDialog from "@/components/dialogs/DefaultDialog";
import ConnectionSelect from "@/components/globals/ConnectionSelect";
import ResetPassword from "@/components/dialogs/ResetPassword";

export default {
  name: "AppToolbar",
  components: {
    DefaultDialog,
    HotelSelector,
    ResetPassword,
    ConnectionSelect,
    LanguageSwitch,
    LogOut,
  },
  mixins: [dialogs, isMobile],
  computed: {
    showConnectionSelect() {
      return this.user.cloudData.length > 1;
    },
    hideHotelSelector() {
      return (
        this.user.cloudData.length === 1 &&
        this.user.hotels.trim().split(";").length === 1 &&
        this.user.hotels.trim().split(";")[0] !== ""
      );
    },
    ...mapState(["user", "currentHotel"]),
  },
};
</script>
